export default [
  {
    name: "tentacleModel",
    type: "gltfModel",
    path: "/assets/models/tentacle.glb",
    // path: "/assets/models/Tentacle/glTF/Tentacle.gltf",
  },
];
